import HeaderPortal from "components/portal/header-portal";
import { Button } from "ui/components/button";
import CreateItemButton from "components/buttons/create";
import EmployeeInput from "components/employee/input";
import { PermissionGate } from "permissions/components/gate";
import React from "react";
import { useState } from "react";
import { addEmployeeAccess } from "./api";
import { eventBus } from "utils/eventBus";
import { toast } from "sonner";
import { invalidateAllQueries } from "utils/utils";

const RepoEmplopyeesInputSheet = ({ employees, show, repository_url, repo_id }) => {
  const [selectedEmployees, setSelectedEmployees] = useState([]);

  const handleConfirm = async () => {
    if (selectedEmployees.length > 0 && repository_url) {
      try {
        const response = await addEmployeeAccess({
          repository_url,
          employees: selectedEmployees.map((emp) => emp.id),
        });
        toast.success(response?.message || "Employees successfully added to GitHub repository! ✨");
        invalidateAllQueries();
        eventBus.emit("refresh:list", `github/repository/list_access${repo_id}`);
      } catch (error) {
        const errorMessage = error?.response?.errors?.[0]?.message || error?.message || "Failed to add employees to GitHub repo";
        toast.error(errorMessage);
        console.error(error);
      }
    }
  };

  function renderFooter({ setOpen, setSelectedEmployees }) {
    return (
      <Button
        onClick={() => {
          handleConfirm();
          setSelectedEmployees([]);
          setOpen(false);
        }}
      >
        Select
      </Button>
    );
  }

  if (!show) {
    return null;
  }

  return (
    <>
      <EmployeeInput
        multiselect={true}
        value={selectedEmployees}
        onChange={setSelectedEmployees}
        allowRemoval={true}
        footer={renderFooter}
        excludedEmployeeIds={[
          ...((employees?.items || employees) || []).map((item) => item.employee.id),
          ...selectedEmployees.map((emp) => emp.id),
        ]}
        filters={{
          github_username: { _null: false },
        }}
      >
        <HeaderPortal>
          <PermissionGate
            rule="update:PC,JC"
            collection="jobs"
            showWhenDisabled={false}
          >
            <CreateItemButton>Employees</CreateItemButton>
          </PermissionGate>
        </HeaderPortal>
      </EmployeeInput>
    </>
  );
};

export default RepoEmplopyeesInputSheet;
